/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

export const ModSafety: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3 3.80087C1.71869 4.92176 1 6.42912 1 8V10C0.447715 10 0 10.4477 0 11V12C0 12.5523 0.447715 13 1 13H5.17071C5.58254 14.1652 6.69378 15 8 15C9.30622 15 10.4175 14.1652 10.8293 13H15C15.5523 13 16 12.5523 16 12V11C16 10.4477 15.5523 10 15 10V8C15 6.42912 14.2813 4.92176 13 3.80087V6.5C13 6.77614 12.7761 7 12.5 7C12.2239 7 12 6.77614 12 6.5V3.07606C11.6824 2.8865 11.3478 2.72036 11 2.57895V8.5C11 8.77614 10.7761 9 10.5 9C10.2239 9 10 8.77614 10 8.5V2C10 1.44772 9.55229 1 9 1H7C6.4478 1 6.00014 1.44757 6 1.99974L6 8.5C6 8.77614 5.77614 9 5.5 9C5.22386 9 5 8.77614 5 8.5L5 2.57895C4.65217 2.72036 4.3176 2.8865 4 3.07606V6.5C4 6.77614 3.77614 7 3.5 7C3.22386 7 3 6.77614 3 6.5V3.80087ZM8 14C9.10457 14 10 13.1046 10 12C10 10.8954 9.10457 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14Z'
				fill='currentColor'
			/>
		</Svg>
	);
};
